import { useCallback } from 'react'
import {
  getGoalAttainmentVarianceReport,
  type GoalAttainmentVarianceReportResult,
  type ReportBucketType,
} from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type GoalAttainmentFinanceData = GoalAttainmentVarianceReportResult

export type UseGoalAttainmentFinanceResult = {
  loading: boolean
  error: string | null
  data: GoalAttainmentFinanceData | null
  bucketLabel: string
}

export function useGoalAttainmentFinance(
  toolbarSelection: Record<string, string>,
): UseGoalAttainmentFinanceResult {
  const getBucketFromData = useCallback(
    (data: GoalAttainmentVarianceReportResult): ReportBucketType =>
      data.productionByPeriod.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getGoalAttainmentVarianceReport,
    getBucketFromData,
    errorMessage: 'Failed to load goal attainment data',
  })
}
